import * as Yup from 'yup';

// const duplicateAddressValidator = (value: any) => {
//   const allAddresses = value.projectBuildings.reduce((acc: any, building: any) => {
//     Array.isArray(building.buildingFloors) &&
//       building.buildingFloors?.forEach((floor: any) => {
//         Array.isArray(floor.buildingLots) &&
//           floor.buildingLots?.forEach((lot: any) => {
//             acc.push(lot.address);
//           });
//       });
//     return acc;
//   }, []);

//   const uniqueAddresses = new Set(allAddresses);
//   return uniqueAddresses.size === allAddresses.length;
// };

const duplicateAddressValidator = (value: any) => {
  const allAddresses = value.projectBuildings.reduce((acc: any, building: any) => {
    if (Array.isArray(building.buildingFloors)) {
      building.buildingFloors.forEach((floor: any) => {
        if (Array.isArray(floor.buildingLots)) {
          floor.buildingLots.forEach((lot: any) => {
            acc.push(lot.address);
          });
        }
      });
    }
    if (Array.isArray(building.buildingCommonAreas)) {
      building.buildingCommonAreas.forEach((area: any) => {
        acc.push(area.address);
      });
    }
    return acc;
  }, []);

  const uniqueAddresses = new Set(allAddresses);
  return uniqueAddresses.size === allAddresses.length;
};

const duplicateUnitNameValidator = (value: any) => {
  const allUnitNames = value.projectBuildings.reduce((acc: any, building: any) => {
    if (Array.isArray(building.buildingFloors)) {
      building.buildingFloors.forEach((floor: any) => {
        if (Array.isArray(floor.buildingLots)) {
          floor.buildingLots.forEach((lot: any) => {
            acc.push(lot.unitName);
          });
        }
      });
    }
    if (Array.isArray(building.buildingCommonAreas)) {
      building.buildingCommonAreas.forEach((area: any) => {
        acc.push(area.commonAreaName);
      });
    }
    return acc;
  }, []);

  const uniqueUnitNames = new Set(allUnitNames);
  return uniqueUnitNames.size === allUnitNames.length;
};

const duplicateJobsiteValidator = (value: any) => {
  const allJobsites = value.projectBuildings.reduce((acc: any, building: any) => {
    if (Array.isArray(building.buildingFloors)) {
      building.buildingFloors.forEach((floor: any) => {
        if (Array.isArray(floor.buildingLots)) {
          floor.buildingLots.forEach((lot: any) => {
            acc.push(lot.jobsite);
          });
        }
      });
    }
    if (Array.isArray(building.buildingCommonAreas)) {
      building.buildingCommonAreas.forEach((area: any) => {
        acc.push(area.jobsite);
      });
    }
    return acc;
  }, []);

  const uniqueJobsites = new Set(allJobsites);
  return uniqueJobsites.size === allJobsites.length;
};

const duplicateJobNumberValidator = (value: any) => {
  const allJobNumbers = value.projectBuildings.reduce((acc: any, building: any) => {
    if (Array.isArray(building.buildingFloors)) {
      building.buildingFloors.forEach((floor: any) => {
        if (Array.isArray(floor.buildingLots)) {
          floor.buildingLots.forEach((lot: any) => {
            if (lot.jobNumber) {
              acc.push(lot.jobNumber);
            }
          });
        }
      });
    }
    if (Array.isArray(building.buildingCommonAreas)) {
      building.buildingCommonAreas.forEach((area: any) => {
        if (area.jobNumber) {
          acc.push(area.jobNumber);
        }
      });
    }
    return acc;
  }, []);

  const uniqueJobNumbers = new Set(allJobNumbers);
  return uniqueJobNumbers.size === allJobNumbers.length;
};

const lotValidationSchema = Yup.object().shape({
  unitName: Yup.string().required('Lot/Unit is required'),
  // jobNumber: Yup.string().required('Builder Job Number is required'),
  jobsite: Yup.string().required('Jobsite is required'),
  lotType: Yup.string()
    .nullable()
    .when('isUnitCreationCompleted', ([isUnitCreationCompleted], schema) => {
      return isUnitCreationCompleted !== true ? schema.required('Lot Type is required') : schema.notRequired();
    }),
  address: Yup.string().required('Address is required'),
});

const floorValidationSchema = Yup.object().shape({
  unitsCount: Yup.string().required('Unit count is required'),
  floorNo: Yup.string().required('Floor number is required'),
  buildingLots: Yup.array().of(lotValidationSchema),
});

const buildingValidationSchema = Yup.object().shape({
  buildingName: Yup.string().required('Building name is required'),
  floorsCount: Yup.string().required('Floor count is required'),
  buildingCommonAreas: Yup.array(
    Yup.object({
      commonAreaName: Yup.string().required('Name is required'),
      commonAreaFloorNo: Yup.string().required('Floor number is required'),
      // jobNumber: Yup.string().required('Builder Job Number is required'),
      jobsite: Yup.string().required('Jobsite is required'),
      // lotType: Yup.string().required('Lot Type is required'),
      address: Yup.string().required('Address is required'),
    })
  ),
  buildingFloors: Yup.array().of(floorValidationSchema),
});

export const getProjectBuildingsValidationSchema = (shouldValidateAddresses: boolean) => {
  console.log('shouldValidateAddresses', shouldValidateAddresses);

  let schema = Yup.object()
    .shape({
      projectBuildings: Yup.array().of(buildingValidationSchema),
    })
    .test('unique-unitNames', 'Each unit name must be unique across all buildings', duplicateUnitNameValidator)
    .test('unique-jobsites', 'Each jobsite must be unique across all buildings', duplicateJobsiteValidator)
    .test(
      'unique-jobNumbers',
      'Each builder job number must be unique across all buildings',
      duplicateJobNumberValidator
    );

  if (shouldValidateAddresses) {
    schema = schema.test(
      'unique-building-addresses',
      'Address must be unique across all buildings',
      duplicateAddressValidator
    );
  }

  return schema;
};
